import { useState, useContext } from "react";
import InputActions from "../InputActions/InputActions";

import { FormBuilderContext } from "../FormBuilderContext";

import "./FormColumns.less";

const FormColumn = ({ AddActionBtn, item, onAction, onSubStartEdit, onSubDelete }) => {
   const Input = item?.Input || null;
   const { previewMode } = useContext(FormBuilderContext);

   return Input ? (
      <div className="form-builder-column-input">
         <Input
            item={item}
            onAction={onAction}
            onStartEdit={onSubStartEdit}
            onDelete={onSubDelete}
         />
      </div>
   ) : (
      !previewMode && (
         <div className="form-builder-column">
            <AddActionBtn />
         </div>
      )
   );
};

const FormColumns = ({
   AddActionBtn,
   onStartEdit,
   onSubStartEdit,
   onDuplicate,
   onSubDelete,
   onDelete,
   items = [],
   onAction,
}) => {
   const { previewMode } = useContext(FormBuilderContext);

   return (
      <div className="form-builder-columns">
         <FormColumn
            item={items[0]}
            onAction={(...props) => onAction(...props, 0)}
            AddActionBtn={() => AddActionBtn(0)}
            onSubStartEdit={() => onSubStartEdit(0)}
            onSubDelete={() => onSubDelete(0)}
         />
         <FormColumn
            item={items[1]}
            onAction={(...props) => onAction(...props, 1)}
            AddActionBtn={() => AddActionBtn(1)}
            onSubStartEdit={() => onSubStartEdit(1)}
            onSubDelete={() => onSubDelete(1)}
         />

         <InputActions onStartEdit={onStartEdit} onDuplicate={onDuplicate} onDelete={onDelete} />
      </div>
   );
};

export default FormColumns;
